export default {
    message: {
        'header': {
            'online': 'online'
        },
        'footer': {
            'home': 'Home',
            'points': 'Punkte',
            'vip_zone': 'VIP Zone',
            'order': 'Bestellung',
            'account': 'Konto'
        },
        'index': {
            'notice1': "Glückwunsch an den Spieler",
            'notice2': "'s Teilnahme, gewonnen",
            'notice3': "Gratulieren ihm!",
            'hot_spot': 'HOT SPOT',
            'all_goods': 'Alle Waren',
            'promotion_type': 'Aktionstyp',
            'partners': 'Partner',
            'announcement': 'Die Ansage',
            'cancel': 'Abbrechen',
            'travel_to': 'Reisen nach',
            'ok': 'OK'
        },
        'goods': {
            'name1': 'Doppelte Rückerstattung',
            'name2': 'Bargeld x2 Rendite',
            'name3': '70-fache Rückerstattung(VIP1)',
            'name4': 'Bargeld x72 Rendite'
        },
        'img': {
            'banner1': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/b1e3c2a662e7333346ef1446db67b4c4.jpeg',
            'banner2': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/c9bf70863920f2a2ac53de21510d71c0.jpeg',
            'banner3': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/069a377136fa1234618c073b166f7ddd.jpeg',
            'banner4': 'https://manage.im2015.com//uploads/attach/2020/03/20200307/4a31597de7b1cc2674314bd8644415f2.jpg',
            'goods_img_10': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/a416c1aa63c2ca77eefa6cd89f376fc0.jpeg',
            'goods_img_50': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5ecd1c7981b5a4b58aed1e761e388ec7.jpeg',
            'goods_img_5': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/91e6995aeab9e5642b09289981288bd5.jpeg',
            'goods_img_150': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/1d5e4e5c3f6cb2e75a773f2c4bfaf014.jpeg',
            'goods_img_25': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/86d508dec4193df34ca3d10ec08eca8b.jpeg',
            'goods_img_500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/81f89dadca780f51c92416a95ee3328c.jpeg',
            'goods_img_1500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/69a61a0dfd4998c560b96500d41f9c5f.jpeg',
            'goods_img_2500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5f47a07b067b6e3acc27a1e384572a69.jpeg',
            'goods_img_return': 'https://zhouyaoming.in2015.com//uploads/attach/2021/06/20210615/f5c725953f90a25e5111bd5b14d4952f.png'
        },
        'detail': {
            'please_select': 'Bitte auswählen',
            'product_description': 'Produktbeschreibung',
            'check_out': 'Kasse',
            'original_price': 'Original Preis',
            'inventory': 'Inventar',
            'sold': 'Verkauft',
            'tip_start': 'Promotion-Erfolg kann auf Waren im Wert von aufgewertet werden ',
            'tip_end': ' Kostenloser Münztausch ',
            'quantity': 'Menge',
            'total_price': 'Gesamtpreis',
            'win_rate': 'Gewinnrate',
            'predict_type': 'Vorhersagetyp',
            'member_shared': 'Sharing-Mitglieder erhalten',
            'share_now': 'Jetzt teilen',
            'copy_the_link': 'Kopieren der Link',
            'send_to_friend': 'An Freund senden',
            'copy_success': 'Kopiererfolg',
            'copy_error': 'Kopierfehler'
        },
        'integral': {
            'title': 'Punktetauschzone',
            'search': 'Suche nach Produktinformationen',
            'points': 'Punkte'
        },
        'vip_zone': {
            'title': 'VIP-Warenliste',
            'price': 'Preis',
            'sales_volume': 'Der Umsatz'
        },
        'login': {
            'account_login': ['Account Login'],
            'login': 'Login',
            'phone': 'Tragen Sie ihre Telefonnummer ein',
            'pwd': 'Geben Sie ihre Passwort ein',
            'no_account': 'Haben Sie ein bestehendes Konto?',
            'forgot_password': 'Passwort vergessen',
            'register': 'Registrieren'
        },
        'reset_pwd': {
            'title': 'Passwort abrufen',
            'get_verification_code': 'Bestätigungscode abrufen',
            'confirm': 'Bestätigen',
            'verification_code': 'Bestätigungscode',
            'your_new_pwd': 'Dein neues Passwort',
            'reload': 'Neu laden',
            'msg_phone': 'Bitte geben Sie ihre Telefonnummer ein'
        },
        'register': {
            'register_account': 'Account registrieren',
            'account': 'Telefonnummer',
            'pwd': 'Passwort Login',
            'con_pwd': 'Passwort bestätigen',
            'register': 'registrieren',
            'tip_account': 'Habe ein bestehendes Konto?',
            'by_click': 'Durch Klicken auf "Registrieren" stimme ich zu Interessantes Einkaufszentrum',
            'privacy_policy': 'Datenschutz-Bestimmungen',
            'tip_wrong': '*Mit einer falschen Handynummer kann die Website nicht normal genutzt werden.',
            'msg_phone': 'Der Telefonformatfehler'
        },
        'order': {
            'submit_order': 'Bestellung abschicken',
            'item': 'Artikel',
            'payment_method': 'Bezahlverfahren',
            'pay_via_balance': 'Zahlung per Guthaben',
            'balance_available': 'Guthaben verfügbar',
            'total_price': 'Gesamtpreis',
            'total': 'Gesamt',
            'check_out': 'Kasse',
            'msg_param': 'Parameter ist falsch',
            'msg_order_field': 'Fehler beim Laden der Bestelldaten',
            'msg_select_payment': 'Bitte Zahlungsmethode auswählen',
            'tip_create_order': 'Ordnung schaffen...',
            'payment_succeeded': 'Zahlung erfolgreich',
            'payment_fail': 'Zahlung fehle',
            'order_no': 'Best.-Nr.',
            'order_time': 'Bestellzeitpunkt',
            'other': 'Sonstiges',
            'total_amount': 'Gesamtsumme',
            'failure_reason': 'Ausfallgrund',
            'view_payment_results': 'Zahlungsergebnisse anzeigen',
            'payment_failed_to_repay': 'Zahlung konnte nicht zurückgezahlt werden',
            'top_up': 'aufladen',
            'hot_spot': 'HOT SPOT',
            'back_home': 'Zurück home',
            'msg_create_success': 'Bestellung erfolgreich erstellt',
            'confirm_title': 'Zahlen',
            'confirm_msg': 'Bezahlung fehle,',
            'confirm_cancel': 'Abbrechen',
            'confirm_top_up': 'aufladen',
            'game_odd': 'Ungerade',
            'game_even': 'gerade',
            'game_title': 'Ungerade oder gerade',
            'game_select_title': 'Wählen Sie Ihr erwartetes Ergebnis aus',
            'game_odd_number': 'Ungerade Zahl',
            'game_even_number': 'Gerade Zahl',
            'game_confirm_selection': 'Auswahl bestätigen',
            'game_opening_time': 'Öffnungszeit',
            'game_issue': 'Problem',
            'game_number': 'Nummer',
            'game_results': 'Ergebnisse',
            'game_submit_err': 'error:Bestellung_id ist nicht vorhanden!',
            'game_choose_least': 'Bitte wählen Sie mindestens eine aus!',
            'game_success': 'Erfolg',
            'game_error': 'Fehler',
            'game_confirm': 'Bestätigen',
            'game_confirm_title': 'Botschaft',
            'game_confirm_msg': 'Bist du sicher, dass du diesen auswählst??',
            'game_confirm_cancel': 'Abbrechen',
            'chart': 'Diagramm',
            'close': 'Schließung',
            'bulls_eye': 'BULLAUGE',
            'trend_recent': 'Trend der letzten 50 Perioden',
            'number': 'Nummer',
            'times_without': 'Keine Zeit',
            'bet': 'Wette'
        },
        'my_order': {
            'title': 'Meine Bestellung',
            'operated': 'betrieben',
            'receive': 'Erhalten',
            'completed': 'Vollendet',
            'converted': 'Umgewandelt',
            'refund': 'Erstattung',
            'item_total_amount': 'Artikel，Gesamtbetrag',
            'picking_up': 'Aufheben',
            'redeem_points': 'Punkte einlösen',
            'processing_pick_up': 'Bearbeitung zur Abholung',
            'hot_spot': 'HOT SPOT',
            'view_details': 'Details anzeigen',
            'check_tracking': 'Tracking-Informationen überprüfen',
            'confirm_receival': 'Empfang bestätigen',
            'receipt': 'Erhalt',
            'cancel': 'Abbrechen',
            'confirm_pick_up': 'Abholung bestätigen',
            'not_sales': 'Ist noch nicht im Verkauf',
            'sales_failed': 'Verkauf fehlgeschlagen',
            'sales_success': 'Verkaufserfolg',
            'waiting_draw': 'Warten auf Auslosung',
            'bonus_countdown': 'Bonus countdown',
            'redeem_success': 'Erfolg einlösen',
            'awarded': 'Ausgezeichnet',
            'points': 'Punkte',
            'fee': 'Gebühr',
            'cash': 'Kasse',
            'sure': 'sicher',
            'detail_title': 'Bestelldetails',
            'detail_copy': 'Kopieren',
            'detail_order_no': 'Best.-Nr.',
            'detail_order_time': 'Bestellzeitpunkt',
            'detail_type_order': 'Auftragsart',
            'detail_status_payment': 'Zahlungsstatus',
            'detail_have_pay': 'Muss bezahlen',
            'detail_did_pay': 'Nicht bezahlt',
            'detail_promotion_status': 'Aktionsstatus',
            'detail_promotion_period': 'Aktionszeitraum',
            'detail_promotion_games': 'Werbespiele',
            'detail_opening_time': 'Öffnungszeit',
            'detail_my_choice': 'Meine Wahl',
            'detail_lottery_numbers': 'Lottozahlen',
            'detail_payment_method': 'Bezahlverfahren',
            'detail_total_amount': 'Gesamtsumme',
            'detail_amount_paid': 'Bezahlter Betrag',
            'detail_re_order': 'Nachbestellen'
        },
        'user': {
            'account': 'Konto',
            'available_balance': 'Verfügbares Guthaben',
            'my_points': 'Meine Punkte',
            'active_code': 'Aktiv-Code',
            'your_code': 'Gib deinen Code ein',
            'msg_code': 'Bitte geben Sie den Umtauschcode ein',
            'ok': 'OK',
            'deposit': 'Anzahlung',
            'withdraw': 'Zurückziehen',
            'confirm_title': 'Bestätigen Sie die Änderung?',
            'confirm_msg': 'Benutzeravatar ändern',
            'confirm_cancel': 'Abbrechen',
            'confirm_ok': 'Bestätigen Sie',
            'cancelled': 'Abgesagt',
            'profile_title': 'Benutzerprofil',
            'profile_manage_account': 'Mein Konto verwalten',
            'profile_nickname': 'Spitzname',
            'profile_real_name': 'echter Name',
            'profile_email': 'Email',
            'profile_phone': 'Phone',
            'profile_password': 'Password',
            'profile_click_change_password': 'Klicken Sie auf Passwort ändern',
            'profile_save_the_change': 'Speichern die Änderung',
            'profile_log_out': 'Ausloggen',
            'profile_confirm_title': 'Ausloggen',
            'profile_confirm_msg': 'Ausloggen bestätigen?',
            'profile_confirm_cancel': 'Abbrechen',
            'profile_confirm': 'Bestätigen',
            'change_password_title': 'Passwort ändern',
            'change_password_current_pwd': 'Giben Sie ihr aktuelles Passwort ein',
            'change_password_set_new_pwd': 'Legen Sie Ihr neues Passwort fest',
            'change_password_confirm_new_pwd': 'Bestätige neues Passwort',
            'change_password_confirm_change': 'Änderung bestätigen',
            'change_password_msg_current_pwd': 'Bitte geben Sie Ihr aktuelles Passwort ein',
            'change_password_msg_new_pwd': 'Bitte geben Sie Ihr neues Passwort ein',
            'change_password_msg_new_pwd_again': 'Bitte geben Sie Ihr neues Passwort erneut ein',
            'change_password_msg_not_match': 'Passwort stimmt nicht überein',
            'user_rank_title': 'Rekord bei der Preisverleihung',
            'user_menu_bulletin': 'Bekanntmachung',
            'user_menu_vip': 'VIP',
            'user_menu_binance_pay': 'Binance-Zahlung',
            'user_menu_agent': 'Agent',
            'user_menu_balance_details': 'Kontostandsdetails',
            'user_menu_lottery_record': 'Lotto-Rekord',
            'user_menu_service': 'Service',
            'user_menu_about_us': 'Über uns'
        },
        'balance_detail': {
            'title': 'Details zum Saldo',
            'total_amount': 'Gesamtsumme',
            'top_up': 'Aufladen',
            'accumulated_withdrawal': 'Kumulierte Auszahlung',
            'bill_record': 'Rechnungsdatensatz',
            'consumption_records': 'Verbrauchsaufzeichnungen',
            'recharge_records': 'Aufzeichnungen aufladen',
            'points_center': 'Punktezentrum',
            'sign_in': 'Melden Sie sich an, um Punkte zu sammeln',
            'upgrade_level': 'Verbessere Level, um mehr Spiel freizuschalten！'
        },
        'my_pay': {
            'title': 'E-Wallet verknüpfen',
            'phone': 'Phone',
            'phone_plac': 'Geben Sie Ihr Telefon ein',
            'binance_id': 'Binance ID',
            'binance_id_plac': 'Binance-ID eingeben',
            'pay_nickname': 'Spitznamen bezahlen',
            'pay_id': 'Bezahl ID',
            'pay_id_plac': 'Bezahl ID eingeben',
            'tip': 'Bitte vergewissern Sie sich, dass alle Angaben korrekt sind, sonst können Sie nicht abheben.',
            'bind': 'Binden',
            'edit': 'Bearbeiten',
            'msg_nickname': 'Bitte geben Sie den Bezahl-Spitznamen ein',
            'confirm_msg': "<b style='color: red'>Note</b>: Bezahl-Spitzname kann nur einmal geändert werden ! ! !<br>Bezahl-Spitzname:",
            'confirm_title': 'Binance Bezahl-Spitzname Bearbeiten',
            'confirm_cancel': 'Abbrechen',
            'confirm_cancelled': 'Abgesagt',
            'confirm_confirm': 'Bestätigen',
            'msg_phone': 'Bitte Telefonnummer eingeben',
            'msg_binance_id': 'Bitte geben Sie die Binance-ID ein',
            'msg_binance_id_format': 'Binance-ID-Formatfehler',
            'msg_pay_nickname': 'Bitte geben Sie den Bezahl-Spitznamen ein',
            'msg_pay_id': 'Bitte Bezahl ID eingeben',
            'msg_pay_id_format': 'Fehler im Bezahl ID Format',
            'msg_pay_id_length': 'Fehler bei der Länge der Bezahl ID',
            'msg_binance_pay': 'Binance ID ist keine Bezahl ID, Bezahl ID finden Sie auf der Empfangsseite.',
            'msg_confirm_title': 'Informationen zur Binance Bezahl-Bestätigung',
            'msg_confirm_msg1': 'Ihr Spitzname-Spitzname',
            'msg_confirm_msg2': 'Ihre Bezahl ID',
            'msg_confirm_msg3': 'Hinweis: Nach der Bestätigung kann die Bindung nicht mehr gelöst werden!',
            'msg_confirm_cancel': 'Abbrechen',
            'msg_confirm_cancelled': 'Abgesagt',
            'msg_confirm': 'Bestätigen',
            'bind_success_msg': 'Erfolgreich verbunden, Sie haben'
        },
        'user_bill': {
            'title': 'Details zum Saldo',
            'all': 'Alle',
            'consumption': 'Verbrauch',
            'recharge': 'Aufladen',
            'income': 'Einkommen'
        },
        'user_integral': {
            'title': 'Details zu den Punkten',
            'current_points': 'Aktuelle Punkte',
            'accumulated_points': 'Gesammelte Punkte',
            'accumulated_consumption': 'Kumulierter Verbrauch',
            'obtained_today': 'Heute erhalten',
            'details_points': 'Details zu den Punkten',
            'increase_points': 'Punkte erhöhen',
            'points_rewarded_purchasing': 'Punkteprämien für den Kauf von Waren',
            'earn_points': 'Verdiene Punkte',
            'points_rewarded_sign': 'Tägliche Check-in-Bonuspunkte',
            'sign_points': 'Punkte',
            'sign_details': 'Einzelheiten',
            'sign_signed': 'Bereits eingeloggt',
            'sign_sign': 'Einloggen',
            'sign_accumulated_sign': 'Kumulierte eingelogen',
            'sign_days': 'Tage',
            'sign_tip2_s': 'Es wird gesagt, dass die',
            'sign_tip2_e': ' Aufeinanderfolgendes Einchecken bringt reichhaltige Punkte, vergessen Sie nicht, einzuchecken ~~~',
            'sign_click_load_more': 'Klicken um mehr zu laden',
            'sign_success': 'Eingelogen erfolgreich',
            'sign_awarded': 'Ausgezeichnet',
            'sign_sure': 'sicher',
            'sign_cnum': ["null", "eins", "zwei", "drei", "vier", "fünf", "sechs", "sieben", "acht", "neun"],
            'sign_msg_signed': 'Sie haben sich heute angemeldet!',
            'detail_title': 'Punkte bestellen',
            'detail_phone': 'Phone',
            'detail_payment_method': 'Bezahlverfahren',
            'detail_pay_with_points': 'Mit Punkten bezahlen',
            'detail_available_points': 'Verfügbare Punkte',
            'detail_total': 'Gesamt',
            'detail_points': 'Punkte',
            'detail_check_out': 'Kasse',
            'pay_points': 'Bezahle die Punkte',
            'detail_parameter_wrong': 'Parameter ist falsch',
            'detail_failed_data': 'Fehler beim Laden der Bestelldaten',
            'detail_creating_order': 'Ordnung schaffen...',
            'detail_creating_order_fail': 'Auftragserstellung fehlgeschlagen',
            'detail_status_title': 'Erfolgreicher Warenaustausch',
            'detail_status_check_mailbox': 'Bitte überprüfen Sie Ihr Postfach, wir liefern das Produkt innerhalb von 24 Stunden.',
            'detail_status_view_order': 'prüfe die Reihenfolge',
            'detail_status_back_home': 'Zurück home',
            'detail_points_title': 'Details zu den Punkten',
            'my_order_points_title': 'Meine Punktereihenfolge'
        },
        'recharge': {
            'title': 'Aufladeantrag stellen',
            'first_deposit': 'Ersteinzahlungsbonus',
            'use_binance': 'Binance verwenden',
            'choose_amount': 'Bitte Betrag auswählen und fortfahren',
            'current_balance': 'Hinweis: Aktueller Saldo',
            'confirm_top_up': 'Bestätigen Sie die Aufladung',
            'application_details': 'Bewerbungsdetails aufladen',
            'order_number': 'Bestellnummer',
            'application_time': 'Bewerbungszeit',
            'top_up_amount': 'Aufladebetrag',
            'top_up_status': 'Aufladestatus',
            'reviewing': 'Überprüfung',
            'application_success': 'Bewerbungserfolg',
            'application_failed': 'Bewerbung fehlgeschlagen',
            'msg_bind_binance': 'Bitte Binance Pay binden',
            'msg_minimum_bank': 'Mindestens 100 zum Aufladen',
            'msg_minimum_binance': 'Mindestens 1 zum Aufladen',
            'msg_enter_top_up_amount': 'Bitte Aufladebetrag eingeben',
            'confirm_title': 'Einzahlungsdetails bestätigen',
            'confirm_verify_information': 'Bitte überprüfen Sie die Informationen',
            'confirm_tip': 'Verwenden Sie das gebundene Binance Pay, um Geld an eines der folgenden Konten zu senden, klicken Sie auf die obere rechte Ecke, um das Tutorial anzuzeigen.',
            'confirm_our_pay_id': 'Unsere Bazahl-ID',
            'confirm_copy': 'Kopieren',
            'confirm_top_up_amount': 'Aufladebetrag',
            'confirm_confirm_top_up': 'Bestätigen Sie die Aufladung',
            'confirm_msg_copy': 'Kopiererfolg',
            'confirm_msg_enter_amount': 'Bitte geben Sie den Betrag zum Aufladen ein',
            'confirm_transfer_amount': 'Überweisungsbetrag mindestens 1',
            'confirm_alert_mes': 'Bitte bestätigen Sie, dass das gebundene Binance-Pay verwendet wurde, um uns zu bezahlen.<b style=\'color: red\'>Bitte warten Sie 5-10 Minuten, bis Sie ankommen.</b>Wenn Sie Fragen haben, wenden Sie sich bitte an den Kundenservice rechtzeitig.',
            'confirm_alert_title': 'Aufladeantrag stellen',
            'confirm_alert_cancel': 'Abbrechen',
            'confirm_alert_msg_cancelled': 'Abgesagt',
            'confirm_alert_confirm': 'Bestätigen'
        },
        'withdrawal': {
            'title': 'Zurückziehen',
            'link_now_tip': 'Sie haben das E-Wallet noch nicht verlinkt, bitte verlinken und den Auszahlungsantrag erneut einreichen.',
            'link_now': 'Verbinde jetzt',
            'withdrawal_account': 'Auszahlungskonto',
            'phone': 'Phone',
            'binance_id': 'Binance ID',
            'nickname': 'Spitzname',
            'pay_id': 'Bezahl ID',
            'withdraw_amount': 'Betrag beheben',
            'balance': 'Balance',
            'processing_fee': 'Bearbeitungsgebühr',
            'actual_amount': 'tatsächliche Menge',
            'msg_withdrawal_account': 'Bitte Abhebungskonto auswählen',
            'msg_fill_data': 'Bitte geben Sie die Daten ein',
            'msg_phone': 'Bitte Telefonnummer eingeben',
            'msg_binance_id': 'Bitte geben Sie die Binance-ID ein',
            'msg_binance_pay_id': 'Bitte geben Sie die Binance Pay ID ein',
            'msg_pay_id_err': 'Fehler im Bazahl ID Format',
            'msg_withdraw_amount': 'Bitte geben Sie den Auszahlungsbetrag ein',
            'msg_insufficient_balance': 'Mangelhaftes Gleichgewicht',
            'msg_mini_withdraw': 'Mindestens 160 zum Abheben',
            'msg_minimum': 'Minimum',
            'msg_to_withdraw': 'zurückziehen',
            'audit_tip': 'Auszahlung wurde eingereicht und wartet auf Überprüfung',
            'audit_sure': 'sicher'
        },
        'user_vip': {
            'title': 'Mitgliederzentrum',
            'able_purchase': 'Kann Artikel bei kaufen',
            'off': 'Schließung',
            'level_task1': 'Schließen Sie die Einzahlung von 1 USD ab und kaufen Sie 50 Mal Waren, um VIP zu werden!',
            'level_task2': 'Auszahlungsgebühr',
            'level_task3': 'Auszahlungszeit',
            'level_task4': 'H',
            'vip_level_unlocked': 'VIP-Level freigeschaltet',
            'higher_level_unlocked': 'Freischalten auf höherem Level',
            'vip_upgrade_requirements': 'VIP Upgrade Anforderungen',
            'required_tasks': 'Erforderliche Aufgaben',
            'select_one_below': 'Bitte wählen Sie eines der folgenden aus',
            'achieved': 'erreicht',
            'conditions_met': 'Bedingungen nicht erfüllt',
            'accumulated_participation': 'kumulierte Teilnahme am Spiel',
            'achieved_top_up': 'Akkumulierte Aufladung von 50 Münzen',
            'exclusive_coupons': 'exklusive Gutscheine',
            'more_games': 'mehr Spiele',
            'need_recharge': 'Muss 50 Münze aufladen'
        },
        'promoter': {
            'title': 'Initiatorsmanagement',
            'apply_agency': 'Bewerben Sie sich als Agentur und werden Sie einer von uns',
            'become_agent': 'Werden ein Agent',
            'repeatedly_delayed': 'Der Upload kann sich verzögern, bitte warten Sie einen Moment, bitte klicken Sie nicht wiederholt！',
            'current_commission': 'Aktuelle Provision',
            'record': 'aufzeichnen',
            'profit_yesterday': 'Gewinn gestern',
            'accumulated_withdrawal': 'Kumulierte Auszahlung',
            'withdraw': 'zurückziehen',
            'refer_friends': 'Freunde werben',
            'total_agent': 'Gesamtagent',
            'copy_success': 'Kopiererfolg',
            'copy_error': 'Kopierfehler',
            'promoter_achievements': 'Leistungen des Initiators',
            'promoter_orders': 'Initiatorsbestellungen',
            'promoter_ranking': 'Initiatorsrangliste',
            'commission_ranking': 'Provisionsrangliste',
            'list_title': 'Anzahl der Agenten',
            'list_number_agents': 'Anzahl der Agenten',
            'list_people': 'Personen',
            'list_date_joined': 'Beitrittsdatum',
            'list_item': 'Artikel',
            'order_title': 'Kumulierte Bestellungen',
            'order_accumulated_orders': 'Kumulierte Bestellungen',
            'order_commission': 'Kommission',
            'order_time': 'Bestellzeitpunkt',
            'order_mark': 'Markierung',
            'commission_title': 'Initiatorserfolge',
            'commission_accumulated_commission': 'Kumulierte Provision',
            'commission_available': 'Provision zur Auszahlung verfügbar',
            'commission_week': 'Neue Mitglieder diese Woche',
            'commission_month': 'Neue Mitglieder diesen Monat',
            'commission_achievement': 'Leistung',
            'commission_rank_title': 'Provisionsrangliste',
            'commission_rank_current': 'Dein aktuelles Rangliste',
            'commission_rank_yet': 'Du bist noch nicht im Rangliste',
            'rank_title': 'Initiatorsrangliste',
            'cash_record_title': 'Details zur Provisionsabhebung',
            'cash_record_cash_out': 'Auszahlungsprotokoll',
            'user_cash_title': 'Auszahlung der Provision',
            'user_cash_not_link': 'Sie haben sich nicht mit dem E-Wallet verbunden, bitte verbinden Sie sich erneut und senden Sie eine Auszahlungsanfrage.',
            'user_cash_link_now': 'Verbinde jetzt',
            'user_cash_service_provider': 'Dienstleister',
            'user_cash_select_account': 'Bitte Abhebungskonto auswählen',
            'user_cash_binance_pay': 'Binance Pay',
            'user_cash_bank_account': 'Bankkonto',
            'user_cash_bank_account_pla': 'Bitte geben Sie Ihre Bankkontonummer ein',
            'user_cash_ifsc_pla': 'Bitte geben Sie Ihre IFSC Kontonummer ein',
            'user_cash_upi_pla': 'Bitte geben Sie Ihre UPI Kontonummer ein',
            'user_cash_withdraw': 'Zurückziehen',
            'user_cash_minimum': 'Minimum',
            'user_cash_to_withdraw': 'zurückziehen',
            'user_cash_current_commission': 'Aktuelle Provision zur Auszahlung verfügbar',
            'user_cash_account': 'Konto',
            'user_cash_account_pla': 'Bitte geben Sie Ihren Alipay Benutzernamen ein',
            'user_cash_current_withdrawal': 'Aktuelle Auszahlungskommission',
            'user_cash_to_e_wallet': 'Bargeld auf E-Wallet abheben',
            'user_cash_to_balance': 'Auszahlungssaldo',
            'user_cash_insufficient_balance': 'Mangelhaftes Gleichgewicht',
            'user_cash_data_format': 'Daten im falschen Format'
        },
        'service': {
            'title': 'Nachrichtenaufzeichnung',
            'write_email': 'Bitte senden Sie uns eine E-Mail'
        }
    }
};